// /opt/dashboard/frontend/src/pages/ServerPro.js
// 🩺 Szerver Pro — beágyazott Netdata
import React from 'react';

export default function ServerPro() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 48px)', color: '#e0e6ed' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 10, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0 }}>🩺 Szerver Pro</h2>
        <span style={{ color: '#8892a0', fontSize: 13 }}>Netdata — részletes monitoring, előzmények, riasztások</span>
        <span style={{ flex: 1 }} />
        <a
          href="/netdata/" target="_blank" rel="noreferrer"
          style={{ color: '#00d4ff', fontSize: 13, textDecoration: 'none', border: '1px solid #2a2e3a', borderRadius: 8, padding: '6px 12px' }}
        >
          ↗ Megnyitás új lapon
        </a>
      </div>
      <iframe
        src="/netdata/"
        title="Netdata"
        style={{ flex: 1, width: '100%', border: '1px solid #2a2e3a', borderRadius: 12, background: '#1a1d27' }}
      />
    </div>
  );
}
